import React, { useEffect, useState } from "react";
//import { useNavigate } from "react-router-dom";
import api from "../api/axios";
import AdminLayout from "./AdminLayout";

/* ── icons ── */
const EyeIcon    = () => <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><path d="M1 8s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5z" stroke="currentColor" strokeWidth="1.5"/><circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="1.5"/></svg>;
const TrashIcon  = () => <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><path d="M2 4h12M5 4V3a1 1 0 011-1h4a1 1 0 011 1v1M6 7v5M10 7v5M3 4l1 9a1 1 0 001 1h6a1 1 0 001-1l1-9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const SearchIcon = () => <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><circle cx="6.5" cy="6.5" r="4.5" stroke="currentColor" strokeWidth="1.5"/><path d="M10 10L14 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const SpinIcon   = () => <div style={{ width:24, height:24, border:"2px solid #2a2d38", borderTopColor:"#4ade80", borderRadius:"50%", animation:"spin 0.6s linear infinite" }} />;

const Avatar = ({ name, color = "#4ade80" }) => {
  const initials = name ? name.split(" ").map(w=>w[0]).slice(0,2).join("").toUpperCase() : "?";
  return (
    <div style={{ width:36, height:36, borderRadius:"50%", background:`${color}18`, color, display:"flex", alignItems:"center", justifyContent:"center", fontSize:12, fontWeight:700, flexShrink:0 }}>
      {initials}
    </div>
  );
};

const COLORS = ["#4ade80","#60a5fa","#a78bfa","#fbbf24","#f87171","#34d399"];

const AdminUsers = () => {
  //const navigate = useNavigate();

  const [users,       setUsers]       = useState([]);
  const [loading,     setLoading]     = useState(true);
  const [search,      setSearch]      = useState("");
  const [deletingId,  setDeletingId]  = useState(null);
  const [toast,       setToast]       = useState(null);
  const [viewUser,    setViewUser]    = useState(null);

  useEffect(() => { loadUsers(); }, []);

  const loadUsers = async () => {
    try {
      const res = await api.get("/admin/users");
      setUsers(res.data);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer cet utilisateur ?")) return;
    setDeletingId(id);
    try {
      await api.delete(`/admin/users/${id}`);
      setUsers(u => u.filter(x => x.id !== id));
      showToast("Utilisateur supprimé", "danger");
    } catch { showToast("Erreur lors de la suppression", "danger"); }
    setDeletingId(null);
  };

  const filtered = users.filter(u =>
    !search || u.name?.toLowerCase().includes(search.toLowerCase()) || u.email?.toLowerCase().includes(search.toLowerCase())
  );

  if (loading) return (
    <div style={{ display:"flex", alignItems:"center", justifyContent:"center", minHeight:"100vh", background:"#0f1117", flexDirection:"column", gap:12 }}>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      <SpinIcon />
      <p style={{ color:"#8b8fa8", fontSize:13 }}>Chargement des utilisateurs…</p>
    </div>
  );

  return (
    <AdminLayout title="Utilisateurs" subtitle="Administration complète des comptes">
      <style>{css}</style>

      {/* TOOLBAR */}
      <div style={s.toolbar}>
        <div style={s.searchWrap}>
          <span style={s.searchIconWrap}><SearchIcon /></span>
          <input
            style={s.searchInput}
            placeholder="Rechercher par nom ou email…"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>
        <div style={s.countBadge}>{filtered.length} utilisateur{filtered.length !== 1 ? "s" : ""}</div>
      </div>

      {/* TABLE CARD */}
      <div style={s.card}>
        {filtered.length === 0 ? (
          <div style={s.empty}>
            <div style={{ fontSize:32, marginBottom:8 }}>👤</div>
            <div style={{ fontSize:14, color:"#8b8fa8" }}>Aucun utilisateur trouvé</div>
          </div>
        ) : (
          <div style={{ overflowX:"auto" }}>
            <table style={s.table}>
              <thead>
                <tr>
                  {["Utilisateur","Email","Téléphone","Rôle","Actions"].map(h => (
                    <th key={h} style={s.th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map((u, i) => (
                  <tr key={u.id} style={s.tr} className="trow">
                    <td style={s.td}>
                      <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                        <Avatar name={u.name} color={COLORS[i % COLORS.length]} />
                        <div>
                          <div style={{ fontSize:13, fontWeight:600, color:"#e8e9ed" }}>{u.name}</div>
                          <div style={{ fontSize:11, color:"#8b8fa8" }}>ID #{u.id}</div>
                        </div>
                      </div>
                    </td>
                    <td style={{ ...s.td, color:"#8b8fa8", fontSize:13 }}>{u.email}</td>
                    <td style={s.td}>
                      {u.phone
                        ? <span style={s.chip}>{u.phone}</span>
                        : <span style={{ fontSize:12, color:"#4a4d5a" }}>—</span>
                      }
                    </td>
                    <td style={s.td}>
                      <span style={{ fontSize:11, padding:"3px 9px", borderRadius:20, background:"rgba(74,222,128,0.1)", color:"#4ade80", fontWeight:600 }}>
                        Voyageur
                      </span>
                    </td>
                    <td style={s.td}>
                      <div style={{ display:"flex", gap:6, justifyContent:"flex-end" }}>
                        <button style={s.actionBtn} onClick={() => setViewUser(u)} title="Voir">
                          <EyeIcon />
                        </button>
                        <button
                          style={{ ...s.actionBtn, ...s.actionDanger }}
                          onClick={() => handleDelete(u.id)}
                          disabled={deletingId === u.id}
                          title="Supprimer"
                        >
                          {deletingId === u.id ? "…" : <TrashIcon />}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* MODAL VIEW */}
      {viewUser && (
        <div style={s.modalBg} onClick={() => setViewUser(null)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalHeader}>
              <Avatar name={viewUser.name} color="#4ade80" />
              <div>
                <div style={{ fontSize:16, fontWeight:700, color:"#e8e9ed" }}>{viewUser.name}</div>
                <div style={{ fontSize:12, color:"#8b8fa8" }}>Voyageur · ID #{viewUser.id}</div>
              </div>
              <button style={{ ...s.actionBtn, marginLeft:"auto" }} onClick={() => setViewUser(null)}>✕</button>
            </div>
            <div style={s.modalBody}>
              {[["Email", viewUser.email], ["Téléphone", viewUser.phone || "—"]].map(([k, v]) => (
                <div key={k} style={s.modalRow}>
                  <span style={{ fontSize:12, color:"#8b8fa8" }}>{k}</span>
                  <span style={{ fontSize:13, color:"#e8e9ed", fontWeight:500 }}>{v}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* TOAST */}
      {toast && (
        <div style={{ ...s.toast, borderColor: toast.type === "danger" ? "rgba(248,113,113,0.3)" : "rgba(74,222,128,0.3)" }}>
          <span style={{ width:7, height:7, borderRadius:"50%", background: toast.type === "danger" ? "#f87171" : "#4ade80", flexShrink:0 }} />
          {toast.msg}
        </div>
      )}
    </AdminLayout>
  );
};

export default AdminUsers;

const s = {
  toolbar:       { display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:16, gap:12, flexWrap:"wrap" },
  searchWrap:    { position:"relative", flex:1, maxWidth:360 },
  searchIconWrap:{ position:"absolute", left:12, top:"50%", transform:"translateY(-50%)", color:"#8b8fa8", pointerEvents:"none" },
  searchInput:   { width:"100%", padding:"9px 12px 9px 36px", background:"#16181f", border:"0.5px solid #2a2d38", borderRadius:9, fontSize:13, fontFamily:"'Plus Jakarta Sans',sans-serif", color:"#e8e9ed", outline:"none", boxSizing:"border-box" },
  countBadge:    { fontSize:12, color:"#8b8fa8", whiteSpace:"nowrap" },
  card:          { background:"#16181f", border:"0.5px solid #2a2d38", borderRadius:12, overflow:"hidden" },
  table:         { width:"100%", borderCollapse:"collapse", fontSize:13 },
  th:            { padding:"10px 16px", color:"#8b8fa8", fontSize:11, fontWeight:500, textTransform:"uppercase", letterSpacing:"0.5px", borderBottom:"0.5px solid #2a2d38", textAlign:"left", background:"#13151b" },
  td:            { padding:"12px 16px", borderBottom:"0.5px solid #1e2029", verticalAlign:"middle" },
  tr:            {},
  chip:          { fontSize:11, padding:"3px 9px", borderRadius:20, background:"rgba(96,165,250,0.1)", color:"#60a5fa", fontFamily:"'DM Mono',monospace" },
  actionBtn:     { width:30, height:30, borderRadius:8, border:"0.5px solid #2a2d38", background:"#1e2029", color:"#8b8fa8", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", fontSize:13 },
  actionDanger:  { color:"#f87171", borderColor:"rgba(248,113,113,0.2)", background:"rgba(248,113,113,0.08)" },
  empty:         { textAlign:"center", padding:"48px 0", color:"#8b8fa8" },
  modalBg:       { position:"fixed", inset:0, background:"rgba(0,0,0,0.65)", zIndex:300, display:"flex", alignItems:"center", justifyContent:"center" },
  modal:         { background:"#16181f", border:"0.5px solid #2a2d38", borderRadius:14, padding:24, width:"100%", maxWidth:360 },
  modalHeader:   { display:"flex", alignItems:"center", gap:12, marginBottom:20 },
  modalBody:     { display:"flex", flexDirection:"column", gap:0 },
  modalRow:      { display:"flex", justifyContent:"space-between", padding:"10px 0", borderBottom:"0.5px solid #1e2029" },
  toast:         { position:"fixed", bottom:24, right:24, background:"#16181f", border:"0.5px solid", padding:"11px 18px", borderRadius:10, fontSize:13, color:"#e8e9ed", zIndex:999, display:"flex", alignItems:"center", gap:8 },
};

const css = `
  @keyframes spin { to { transform: rotate(360deg); } }
  .trow:hover td { background: #1a1c25 !important; }
  input:focus { border-color: #4ade80 !important; }
`;